import SchemaModel from './schema.model'

let storeContent = utils.generateStore({
   SchemaModel,
   schemata: [],
   selected_schemata: [],
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async updateSchema(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'update',
                  data: {
                     id: ctx.getters.selected_schemata[0]._id,
                     record: {
                        alias: data.alias,
                        description: data.description,
                     }
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "schema",
                  }
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchSchema',{table: ctx.getters.table})
               ctx.commit('show_edit_modal', false)
               $notify('success', 'Schema Updated', `Schema ${res.result.data.name} successfully updated.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      handleActions(ctx, payload) {
         if (payload.action === 'schema:view') {
            
         }else if (payload.action === 'schema:edit') {
            let SchemaModel = ctx.getters.SchemaModel
            SchemaModel.forms.edit_schema.data = payload.rows[0]

            ctx.commit('SchemaModel', SchemaModel)
            ctx.commit('show_edit_modal', true)
            ctx.commit('selected_schemata', payload.rows)
         } 
      },
      async fetchSchema(ctx) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {

                     }
                  }
               },
               meta_data: {
                  service: "analytics",
                  collection: "schema",
               }
            })
            ctx.commit('schemata', res.result.records);
         } catch (err) {
            throw err
         }
      },
      async fetchData(ctx) {
         try {
            await ctx.dispatch('fetchSchema')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};